// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-tooltip[data-v-5e777a96]{display:none!important}.ant-table-cell[data-v-5e777a96]{cursor:pointer!important}.link-click[data-v-5e777a96]{color:#000;text-decoration:none}.link-click[data-v-5e777a96]:hover{color:#08b77e;text-decoration:underline}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
